var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formData.id)?_c('div',{},[_c('ContactForm',{attrs:{"form-data":_vm.formData,"title":_vm.$t('Manage contact')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }